import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer fallback so cross-device sync works even when cookies are blocked
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("flowtasks_access_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err?.response?.status === 401) {
      const original = err.config || {};
      if (!original._retried) {
        original._retried = true;
        try {
          const refresh = localStorage.getItem("flowtasks_refresh_token");
          const res = await axios.post(
            `${API}/auth/refresh`,
            {},
            {
              withCredentials: true,
              headers: refresh ? { Authorization: `Bearer ${refresh}` } : {},
            }
          );
          const newAccess = res.data?.access_token;
          const newRefresh = res.data?.refresh_token;
          if (newAccess) localStorage.setItem("flowtasks_access_token", newAccess);
          if (newRefresh) localStorage.setItem("flowtasks_refresh_token", newRefresh);
          if (newAccess) {
            original.headers = original.headers || {};
            original.headers.Authorization = `Bearer ${newAccess}`;
            return api(original);
          }
        } catch (e) {
          // fall through
        }
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
